import { combineReducers } from "redux";
import { auth } from "./auth/loginReducer";
import { authMessage } from "./auth/authMessageReducer";

export default combineReducers({
    authMessage,
    auth,
});
